import React, { useContext } from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaFacebookSquare,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
import { Context } from "../../utils/context";

const Footer = () => {
  const { language } = useContext(Context);

  return (
    <>
      <footer className="footer_section">
        <div className="container">
          <div className="row">
            {/* LEFT SECTION */}
            <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
              <Link as={Link} to={"/home"}>
                <div className="logo_holder">
                  <img
                    src="/assets/images/logo/Light.png"
                    alt="AF Logo"
                    className="footer_logo"
                  />
                </div>
              </Link>

              <p className="footer_text">
                {language == 1
                  ? "AFIWAY helps students pursue global education and internships with trusted guidance, expert support, and international partnerships."
                  : "AFIWAY aide les étudiants à poursuivre des études et des stages à l’étranger grâce à un accompagnement fiable, un soutien expert et des partenariats internationaux."}
              </p>

              <div className="social_icons mt-3">
                <Link
                  to={"https://www.instagram.com/afiwayglobal/"}
                  target="_blank"
                >
                  <FaInstagram size={22} />
                </Link>
                <Link
                  to={"https://www.linkedin.com/company/afigroup"}
                  target="_blank"
                  className="ms-3"
                >
                  <FaLinkedin size={22} />
                </Link>
                {/* <Link
                  to={"http://facebook.com/"}
                  target="_blank"
                  className="ms-3"
                >
                  <FaFacebookSquare size={22} />
                </Link> */}
              </div>
            </div>

            {/* QUICK LINKS */}
            <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
              <h5>{language == 1 ? "Quick Links" : "Liens rapides"}</h5>
              <ul>
                <li>
                  <Link to="/home">{language == 1 ? "Home" : "Accueil"}</Link>
                </li>
                <li>
                  <Link to="/about-us">
                    {language == 1 ? "About Us" : "À propos de nous"}
                  </Link>
                </li>
                <li>
                  <Link to="/contact-us">
                    {language == 1 ? "Contact Us" : "Contactez-nous"}
                  </Link>
                </li>
                <li>
                  <Link to="/blogs">{language == 1 ? "Blogs" : "Blogs"}</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">
                    {language == 1
                      ? "Privacy Policy"
                      : "Politique de confidentialité"}
                  </Link>
                </li>
                <li>
                  <Link to="/terms-conditions">
                    {language == 1
                      ? "Terms & Conditions"
                      : "Conditions générales"}
                  </Link>
                </li>
              </ul>
            </div>

            {/* SERVICES */}
            <div className="col-lg-2 col-md-6 col-sm-6 mb-4">
              <h5>{language == 1 ? "Services" : "Services"}</h5>
              <ul>
                <li>
                  <Link to="/internship/france">
                    {language == 1 ? "Internship" : "Stage"}
                  </Link>
                </li>
                <li>
                  <Link to="/study-abroad">
                    {language == 1 ? "Study Abroad" : "Étudier à l’étranger"}
                  </Link>
                </li>
              </ul>
            </div>

            {/* MAP */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="map_holder">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3782.563883222077!2d73.93136108199799!3d18.548599997578265!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sThe%20Platinum%20Towers%2C%20Nr%20Bollywood%20Multiplex%2C%20Old%20Mundhwa%20Road%2C%20Tukaram%20Nagar%2C%20Kharadi%2C%20Pune%20%E2%80%93%20411014%2C%20Maharashtra%2C%20IN!5e0!3m2!1sen!2sin!4v1769778132886!5m2!1sen!2sin"
                  className="map_frame"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              {/* COUNTRY LINKS */}
              <div className="country_links mt-4">
                <Link to={"#"}>{language == 1 ? "USA" : "États-Unis"}</Link>
                <Link to={"#"}>
                  {language == 1 ? "India(HQ)" : "Inde (siège)"}
                </Link>
                <Link to={"#"}>{language == 1 ? "Georgia" : "Géorgie"}</Link>
              </div>
            </div>
          </div>

          <div className="copyright_div">
            <p className="copyright_text">
              {language == 1
                ? "©2026 AFIWAY All Rights Reserved. Developed by"
                : "©2026 AFIWAY Tous droits réservés. Développé par"}

              <Link target="_blank" to={"https://profcymaglobal.com"}>
                {" "}
                Profcyma Solutions Pvt Ltd
              </Link>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
